import { Navigate } from 'react-router-dom';
import SignIn from 'components/modal/SignIn';
import useCustomer from 'hooks/useCustomer';

const Login = () => {
	const { customer } = useCustomer();
	if (customer?.token) return <Navigate to="/" replace />;
	return (
		<div style={{ maxWidth: 420, margin: '40px auto', padding: 16 }}>
			<SignIn />
		</div>
	);
};

export default Login;
